import gql from 'graphql-tag';

const QUERY_REASSIGN_ESIM_HISTORIES = gql`
  query reassignEsimHistories($filter: ReassignEsimHistoriesFilterInput, $limit: Int) {
    reassignEsimHistories(filter: $filter, limit: $limit) {
      isSuccess
      message
      reassignEsimHistories {
        id
        esimId
        actionBy {
          id
          firstName
          lastName
        }
        createdAt
        oldUser {
          id
          email
        }
        newUser {
          id
          email
        }
      }
    }
  }
`;

export default QUERY_REASSIGN_ESIM_HISTORIES;
